export const ARTICLE_SLUG_REGEXP =
  'articles\\/([^\\?]+?)(\\/[^\\?]+)*?\\/?(?:\\?[^\\?]+)?$';

export const DISPLAY_PARAM_REGEXP = 'display=page';

export const DISPLAY_PAGE_PARAM = { display: 'page' };
